const gen = {
    _C42AE1989F20D1B6:'中国区',
    _EFECB2208C4D853E:'非中国区',
    _108D239E11B746E5:'注册号信用代码',
    _FCF219943B44B2C8:'法人',
    _B14628DB21685A53:'注册地址',
    _D0CDC5DA95000B55:'基础信息',
    _FF339A81358BD544:'登记信息',
    _B0D25E6EB5FFF192:'注册资本',
    _5D1E56124A77D403:'成立时间',
    _EEB96CFF829AEFAF:'统一社会信用代码',
    _7751E77D724B8E4D:'注册机关',
    _DAA9890CB23D1D1D:'法定代表人',
    _22E316BFDF8585CD:'企业性质',
    _B792D74490AC5846:'机构代码',
    _D6FBEA6F9C5256B1:'企业地位',
    _2EBFE8BA794EA4C5:'经营期限',
    _741B2155A71F27D8:'核准日期',
    _B200C34F56DED50E:'法定经营范围',
    _FCD2908E0EBED360:'股东信息',
    _8C11957BD93982D4:'主要人员',
    _3501FDE979B5A4AF:'对外投资',
    _85F2AF69934F41B4:'企业电话',
    _908BA8F840F48F54:'征信报告',
    _40418567ECD7328F:'企业信用报告',
    _1CCC26B9B107173B:'基本信用报告',
    _48ED6CBE8A4A4C1C:'关联信用报告',
    _798265E1F68AC490:'企业年报',
    _362F374BF5447E1E:'年度报告',
    _2590799346B727D7:'知识产权',
    _7912618EB31420A0:'域名',
    _4E63C7F9B5510FA6:'新闻招聘',
    _37E99711B9471DE3:'新闻',
    _A856DAD4ED1F9BBC:'招聘',
    _43335CD781012715:'标准信用报告（非中国）',
    _BEA758DF3F3EF819:'专业信用报告（非中国）',
    _AE0C9CD6D81B0191:'未找到目标公司？请',
    _9345CF44233D1D3B:'点击下单',
    _DF676765DD3367F8:'立即搜索',
    _BDF821D707987BE9:'未搜索到目标公司？请选择报告类型，填写表单申请。',
    _75C45327C151371E:'中国区企业信用报告',
    _3F2D621AFF46EB3F:'非中国区企业信用报告',
    _33F41449AA6266D5:'征信报告权益',
    _611362D01873C131:'标准信用报告订单',
    _0A9E181A82EAD7BA:'订单基本信息',
    _F0E78FFAFDFD8815:'公司注册号',
    _9F3DD30CC52BFFF9:'请输入目标公司名称',
    _6F31B3C0CE375313:'请输入目标公司地址',
    _9D7D4D50ED3AEF9D:'请输入目标公司电话',
    _2F4EBF6C63C73EDA:'请输入目标公司注册号',
    _3823AFE6403FC52B:'填写更多信息',
    _342C5EBE3EA8531E:'能帮助我们更快地找到目标公司，同时您也能更快获取报告。',
    _9881FBECD092E3A6:'您的联系方式',
    _11AA089BD25E9FE0:'您的公司名称',
    _7F8AA50A26BDCA29:'您的手机号码',
    _A7C8E306F81B1DA3:'您的姓名',
    _1B52C69565300E99:'您的邮箱',
    _C62E597AAA58EA95:'订单速度',
    _41171C31C94496A9:'普通订单（15个工作日）',
    _AC8219498AC131C4:'报告内容',
    _60ED4E39C0687805:'报告语言',
    _179B773879843F93:'中国企业报告语言默认为中文，若需翻译成英文每份加￥300，完成日期延长一天',
    _886C688D040C28D8:'订单价格',
    _B78BE2B0D8E3F85F:'您的报告大约将于<span>{count}个工作日</span>后收到，订单提交后，我们客服会尽快与您取得联系',
    _6FF2FA33E7659D42:'提交',
    _4F11D6331102CAB1:'客户参考号',
    _F4E738C3F084D9C1:'公司邮编',
    _84087137CDF5555B:'公司传真',
    _583291904B67C121:'公司网址',
    _607D5E31D0F47A4E:'公司联系人',
    _6D2E7041A0B79EC9:'公司联系人邮箱',
    _2F8A5EDAF14BF8CF:'公司联系人手机号',
    _7B5149FF3D52E9DF:'备注',
    _368CFF5677AB20D3:'信用决策报告订单',
    _8C3F5A910ABB9F01:'财务信用报告订单',
    _B708B6A67C43EBD6:'目标公司名称',
    _E933500BC49C8B73:'目标高管信息',
    _EE56AF8A953765E2:'*仅提供有进出口权企业的进出口记录报告',
    _581E80E9A2A0ECF2:'该企业无进出口权，暂不提供进出口记录报告',
    _6ECFB04AE63B8E3B:'备注：3天之内客服会与您联系确认目标公司征信报告是否存在，若目标公司无相应征信报告，我们将原款退还。',
    _3AF0EEF0DAEC93D3:'您选择的国家暂不支持在线报告，请填写订单信息。',
    _F967257B46C4AC73:'我的订单',
    _89B1E4B4FB72ACA6:'订单类型',
    _CD83FB1C23735AD1:'订单状态',
    _94DDC31D298FFC74:'订单处理中',
    _CBB75DCC686EE28D:'订单完成',
    _251D996A25A9081F:'订单退款',
    _FC9F647682076BE0:'请输入订单关键词搜索订单',
    _50DF0F91DF131217:'订单号',
    _653AE552ABA7120D:'下单时间',
    _EA2889BD27DA7CB6:'下载',
    _E42E5460A7D47BEB:'订单详情',
    _7F8D31C3CDA7B138:'订单信息',
    _7E512B8D9A1F513C:'企业名称',
    _373E8BE0D8840779:'订单编号',
    _E9002C8639427942:'订单描述',
    _572A34C6E9833BEF:'支付信息',
    _ADE6B6515A35C159:'订单金额',
    _CC892FA32E24130A:'实际支付',
    _9C3B1232D4BA4345:'下载报告',
    _65AAA6747A234191:'确认订单信息',
    _BD93ABEDF335ED06:'支付方式',
    _95700296D892965F:'余额支付',
    _F559F0101FFDE80F:'第三方支付',
    _1F707A28B289C123:'报告概要',
    _A2B00C4D37EF8D04:'企业登记信息',
    _FFBDCA0962ACAD73:'主要管理人员',
    _C4BE6E342A218A30:'基本信息',
    _6430C03219E3C6E7:'注册信息',
    _E9AB8E397E1D84A9:'股东股权',
    _11E7DCD211E03CBC:'管理人员',
    _AAD3749ED7E7DFDE:'财务资料及分析',
    _C5834EDFBB8F6919:'经营信息',
    _366276B8A6FCBE18:'信用记录',
    _4A344D7ABA8A3D16:'司法信息',
    _3AEAD3BFFB49261E:'商标专利',
    _E9FEEF93066D0DB7:'公开记录',
    _D5A38510029D8D64:'行政奖罚',
    _E50796EBE5627917:'企业资质',
    _2BD708AE5C2B8658:'银行信息',
    _439CEA406369A296:'行业背景及指标',
    _B452DF6AE09ACE90:'综合分析',
    _AB288C74A8147006:'信用等级及额度等（由于企业类型和规模不同，报告的内容可能会有所差异）',
    _E8B1494F45E1823A:'信用等级',
    _0DBA5B3705AB3F8A:'额度及信用期限',
    _5E8A621D18ADF05F:'企业经营与动态',
    _FCC20298D733713C:'企业财务信息',
    _0E2756CB27889D56:'行业背景及行业指标',
    _43659561B66B5B6D:'企业风险分析（由于企业类型和规模不同，报告的内容可能会有所差异）',
    _2E5D5454255E0145:'企业基本信息',
    _815FDFC4DABE3A9A:'最新财务状况',
    _3B6F1B2BD90B8ABA:'行业信息',
    _7F5A6399D7FA9FCB:'信用评分及额度',
    _5DB2703036C56C4F:'经营活动',
    _C7AA1D06BC8BF617:'曾用名称',
    _B341130A9B3B4B97:'旧的企业类型',
    _F4BD0286B0EF1508:'联系信息',
    _D04F400509633786:'负面信息',
    _428E6CAF92CBE5AB:'付款信息',
    _0937F10C95DB9D12:'董事/管理人员',
    _63DC1BA360A621DF:'股权结构',
    _328B7C087FF9FA8B:'集团结构',
    _747C1A49D39FCC0E:'关联公司',
    _7B62F7121421F76C:'其他信息',
    _5A6C768555DF305B:'财务信息',
    _C062FC6D69CB9AEA:'损益表',
    _071226E07B78C0FE:'资产负债表',
    _A477D0C7222AB97D:'其他财务信息',
    _C1DF8F5B9B639ED2:'比率（由于企业类型和规模不同，报告的内容可能会有所差异）',
    _32AE7480C5748DAD:'海关评级',
    _AAD1C9F25083F758:'进出口记录',
    _55D2D24204BBFF00:'企业关联信息',
    _69CB8C47FBD7DCA5:'最新财务状况（个别含有）',
    _D214842FE9E291E6:'公共记录',
    _47E2037B97106B23:'司法记录',
    _0BDCE3AD4A5082D7:'高管担任法定代表人',
    _9164CB12CEE9D3F9:'高管在外投资',
    _D5F34645689F3E74:'高管在外任职',
    _CE4E5DE783CE2519:'企业对外投资',
    _25F59D0E09AEC79A:'标准信用报告',
    _C8ACB3D947BFF58E:'信用决策报告',
    _14F9CFD423C00C71:'财务信用报告',
    _E0D04F8141FCD790:'海外在线报告',
    _AA4FF4F728D36439:'海外离线报告',
    _322755C8195C2DA8:'进出口记录报告',
    _66FB6CC362C1E7A2:'高管关联报告',
    _FA3A12C41D899454:'企业关联报告',
    _C79AA2E1C4BFF94F:'全方位洞察企业发展现状',
    _55E93A69117E2919:'预知交易风险',
    _FC8A68E01DA266E9:'做出有利决策',
    _21D7E5D8A30B9664:'迅速洞察客户实力',
    _C320D07D47B1C9EF:'助您识别合作风险',
    _CDB87173DEEC9B25:'快速决策',
    _9EFC529DD6887260:'企业财务状况全面分析',
    _C3C0D3201C9D1439:'有效评估偿债能力',
    _146AC35CFC9D559C:'盈利能力',
    _6ADD89C4F2264B14:'汇集进出口数据&海关评级',
    _C2C6FC45A4E98EED:'助您有效排查交易风险',
    _FE3BD659D5972D70:'抢占市场先机',
    _28609E4A29B0DC12:'汇集进出口数据',
    _152DF7A9DB7AE748:'一键获取企业基本信用情况',
    _8F5B2157C3CEF520:'维度丰富',
    _190CFF21109184E5:'性价比高',
    _A9684446D236BF4C:'有效支持快速决策',
    _29F045EC85979AB0:'展示高管背景',
    _9096AD42BCA1E24C:'掌握关联企业',
    _71F34DBCC1460A2D:'预判交易风险',
    _6A5863FAE0C52811:'深挖关联企业',
    _24560E03362D23EC:'防范风险',
    _A3A129DBA93AD960:'加急',
    _41FDBAC1A7663940:'特急',
    _1B3E8112733CB50A:'普通',
    _09D790D62F41A724:'普通订单',
    _F01431F8B926B2A8:'加急订单',
    _49F2520F7BE2170B:'特急订单',
    _198EA993107833CD:'您提交的公司认证在审核中',
    _C475667934952A08:'您提交的公司认证已审核通过',
    _F1A99ABAA3A70857:'您提交的公司认证未通过审核，请修改后再提交系统审核',
    _390F6F28C9DEE4D0:'您提交的公司上下游在审核中',
    _54F94A48F24A92CC:'您提交的公司上下游已审核通过',
    _5276FF277F161100:'您提交的公司上下游未通过审核，请修改后再提交系统审核',
    _0AA51AA60F02B5AD:'您提交的意见反馈在审核中',
    _CF94FD9A6CCB1145:'您提交的意见反馈已审核通过',
    _4C737C69864AC79F:'您提交的意见反馈未通过审核，请修改后再提交系统审核',
    _B5B792F350314A12:'征信报告已生成',
    _3A2A96BF6BDDC66B:'您的报告已成功生成，请到我的订单中心下载您的报告',
    _9259342BD395862F:'订单通知',
    _35877B9B563CDA0D:'征信报告生成失败',
    _3B9F2A5887298749:'很抱歉，您输入的目标公司无相应征信报告，我们将原款退还',
    _F3D4EDFDA3D730F7:'您的征信报告已退款成功',
    _A362918B62A3B3CE:'您的联系电话',
    _4C1D13253B871BF8:'您的邮箱地址',
    _D5F2C854A21A8F9D:'报告类型',
    _DCA0137D882B1569:'账户余额',
    _576E21636CA8050B:'刷新',
    _6608E89B5B203542:'充值',
    _488E2DF9525EB78F:'提交订单',
    _E41D73EF52565FB3:'请输入内容',
    _7F5A154D10F8E4CC:'请选择',
    _A78B0C0E20923692:'搜索',
    _CD9A7C4D08858782:'注册号',
    _6799AB98CFC957C3:'企业联系电话',
    _C22A3DCE17C95815:'邮政编码',
    _85F2A0D2D7E5A9ED:'企业通信地址',
    _8DCDB6B183A21704:'电子邮箱',
    _44A3F2F4EAB7387D:'有限责任公司本年度是否发生股东(发起人)股权转让',
    _FDE22E8368908B49:'企业经营状态',
    _6DAFDE31DD57E67D:'是否有网站或网店',
    _D57B50DCF68E167A:'企业是否有对外投资设立企业信息',
    _EBF0BD3AD98D7DB8:'从业人数',
    _6FA6268A4CC79C01:'网站或网店信息',
    _D01612AF6B1EE85D:'类型',
    _C34ACDA7DACF54CB:'名称',
    _AED1D9AB6EDA12BE:'网址',
    _861F52A72076998E:'股东及出资信息',
    _B55ED213072D695D:'股东(发起人)',
    _9CB7B0B894740EE6:'认缴出资额(万元)',
    _E1037F1840E1F5B8:'认缴出资时间',
    _108FA0EFED779A9D:'实缴出资额(万元)',
    _F4B40814C3D408EC:'出资日期',
    _B5098F7CA2BD9B48:'出资方式',
    _D32A490F379A4EC5:'对外投资信息',
    _32C2EB8EB4414C29:'投资设立企业或购买期权企业名称',
    _465DB114FC46C912:'企业资产状况',
    _0C760C33A211D35D:'资产总额',
    _D35A810CD44AC3A8:'负债总额',
    _816FD35C491B13B5:'销售总额',
    _7DA6D4EF658AF2D7:'利润总额',
    _D4947A4AC51F33F1:'销售总额中主营业务收入',
    _D42F540C485908EB:'净利润',
    _BB01EFCD8AC76E6A:'纳税总额',
    _9CAD59049F980014:'所有者权益合计',
    _E45D70066D89CD70:'对外提供保证担保信息',
    _D3E31318F5E4FC01:'债权人',
    _C3BA6907DD11BA3A:'债务人',
    _AE9C87B493BB8A36:'主债权种类',
    _C6A2117FAAD47AB6:'主债权数额',
    _1EAA62161687D054:'履行债务的期限',
    _4083F22199C8E38E:'保证的期间',
    _80A9871A093ED452:'保证的方式',
    _F23B0F32AEC3C1EA:'保证担保的范围',
    _97ED12A072E32C7A:'股权变更信息',
    _80D655B93E2CD5EE:'股东',
    _2E7C2688E1AE17E4:'变更前股权比例',
    _C380CB21FEC46617:'变更后股权比例',
    _F497FFC1F82B7A81:'变更日期',
    _7A6DAF301BF39469:'修改记录',
    _9054E8102BE31F07:'修改事项',
    _B980437348C6CC3C:'修改前',
    _CD9504E5343FAD7D:'修改后',
    _5288D6774D159320:'修改日期',
    _4BC5C9AE9D8F6EDD:'公司名称',
    _767DDCA435EF5A0D:'以下均为选填项，可让我们更快找到目标公司，同时您会更快的获取报告',
    _B1012AA778374C49:'请输入客户参考号',
    _4D85895D28F46A6B:'请输入目标公司邮编',
    _BBA120022832DD52:'请输入目标公司传真',
    _4D1E820F87E538CC:'请输入目标公司网址',
    _143AEA38D02DBA93:'请输入目标公司联系人',
    _3998ACF8871BD025:'请输入目标公司联系人邮箱',
    _9C1ED421D685C715:'请输入目标公司联系人手机号',
    _3B86B63CA0BB4EAB:'请输入您的其他需求',
    _E18DB53BB2AFDFE5:'请输入您的公司名称',
    _211E217275F0A9BE:'请输入您的姓名',
    _313601EBF9409213:'请输入您的邮箱地址',
    _D719DD6293A6E32B:'查看报告样本',
    _05062D64F28822F8:'中文',
    _0F7DB03985F4166D:'英文',
    _E40D8942489AF29B:'目标企业信息',
    _B9FFAFA17F984141:'全选',
    _4D5E53F75D3B003E:'请输入高管身份证号/护照号，查询更精准（选填）',
    _0F625AAA0CFC02CC:'vip会员才能提交订单，是否开通vip会员？',
    _1B039DBA24905254:'开通',
    _BF54E1A123011E86:'信用就是资本',
    _9BFD30568442E843:'从这里，获取全球的企业信用管理服务',
    _274D55D888C104DE:'中国',
    _FE86492B8B77C0F7:'非中国',
    _BA857CAE4E2A39EE:'满足所有信用调查需求',
    _AD5C2CF813168405:'我的报告',
    _BB9B2CCD4323ECB2:'确定',
    _15D206D3771D2BCA:'报告详情',
    _558CE585DF178AE3:'元',
    _FDD8ADDF0E19DE64:'中国公司列表',
    _30C6AD872C5D9F00:'共找到约<span>{count}</span>家企业，为您展示前{front}条',
    _DC806EEC155CA5F0:'公司详情',
    _5E5E9CD11863C989:'联系电话',
    _C94FF80392CDF3E2:'简介',
    _D13AD477DC9D355E:'暂无公司简介',
    _AA631B2DD2583BE7:'人民币',
    _8C4FFBA1D09C3D42:'专项信用报告',
    _BE80CBE68207893F:'注册时间',
    _54D23372288B4696:'来源',
    _8B012D89E90E462B:'工作地点',
    _8D7C22F51289659F:'薪酬',
    _433EE42D472D7CE5:'下单成功',
    _A8B3CDCE6ECDFCB3:'您下单购买征信报告已支付成功，我的客服人员会尽快与您取得联系，若目标公司无相应征信报告，我们将原款退还',
    _7BF32D32BBDBDBFA:'暂无企业年报信息',
    _86EBA604673A6287:'暂无知识产权信息',
    _DAD78F91C6F5D37F:'暂无新闻招聘信息',
    _4F419DF0ADA8B931:'中国标准信用报告',
    _B6CE57F276ADA567:'中国信用决策报告',
    _A2027BB46444D4FB:'中国财务信用报告',
    _30D93B194C1C942B:'海外标准信用报告',
    _13E304066C672EE1:'海外在线专业信用报告',
    _2DC686625DC2DD54:'海外离线专业信用报告',
    _7E05356CC20AF027:'中国进出口记录报告',
    _395BDA3B625561C7:'中国基本信用报告',
    _B5CDF55A48182B7A:'中国高管关联报告',
    _D6EACED55DD87490:'中国企业关联报告',
    _CC869AC1A9FC3AA9:'邮箱邀请获得查看联系人额度10次',
    _2BB6686E5F5D2506:'邮箱分享获得额度',
    _054789FE3D92F8EE:'公司认证获得额度',
    _200C3AB2843FC88D:'退款成功',
    _BE32F3ED4DA26C91:'系统通知',
    _EC8DEBEDCBF8A9AC:'已成功退回到您的余额',
    _184D2790C3FBE043:'您已下单成功，我们的客服人员会尽快与您取得联系',
    _A57473800DE3F3BB:'公司认证',
    _D483F385C3B31538:'意见反馈',
    _6CDBFB91A5DD8CD5:'公司上下游',
    _6CE10C1138854A48:'或者，您可以复制以下链接转发',
    _A27C3E84F6D407C3:'订单支付失败',
    _AB85B18BA5D629F0:'请输入目标公司所在国家',
    _55263C127A677B9F:'公司英文地址',
    _F5C2331CCA57E116:'请输入目标公司英文地址',
    _37B2ED9C5348B0BF:'公司英文名',
    _D8C020F68EFA4B27:'请输入目标公司英文名称',
    _07EEA32FB91CE9E8:'公司联系电话',
    _8915CBC3ED44EF0D:'请输入目标公司联系电话',
    _B1387BFBBE467173:'公司名称（用当地语言填写）',
    _8A893879F133DAC3:'请输入您的手机号码',
    _7DF8F3E33E06678D:'选择订单类型',
    _FF1BAFDE4717EA6A:'订单类别',
    _5646913679F809AF:'您的报告将大约于<span>{count}</span>日前收到，订单提交后，我们的客服会尽快与您取得联系。',
    _571028FC767E8570:'未搜索到目标公司？',
    _E86BB502001F5715:'请选择报告类型，填写表单申请',
    _A2045ABA52829947:'专业分析师，有效识别风险',
    _FA5B35DA3E0ECE76:'把握商机，迅速决策',
    _D5086778379D1070:'超乎想象的性价比',
    _A5D97E7993456ADE:'国内信用报告',
    _3FEA1EF958F1DB10:'提供全方位的信用报告，帮助您全面了解目标企业的详细背景、信用记录、最新经营情况、财务信息等，精准分析目标企业的商业实力。',
    _794A78F94FA88B27:'聚焦财务、进出口记录、高管信息等不同领域的专项报告，让您根据自身信用调查需求，针对性获取企业专项信息。',
    _3449CF6B27A783E1:'全面洞察企业现状',
    _B563FFFE212529A2:'多角度剖析目标企业，信息维度丰富并保持及时更新，全面掌握企业的信用动向，甄别合作风险。',
    _96B0345149914A30:'高效决策支持 ',
    _CFAF35D3024C113A:'报告3-7个工作日即可生成。权威分析，有效评估企业真实财务状况及信用风险，为合作决策提供强大数据支持。',
    _2F3A3A366FD8E567:'海外信用报告',
    _4F4B421400C1D552:'权威信息来源渠道',
    _3988D4400FD84E81:'融合海外多家第三方专业机构的报告及授权，权威性更高，信息来源更加及时可靠。 ',
    _4629054970EB083C:'精准调查全球企业',
    _9B6344D062544D38:'多维度评估目标企业信用，辅助自身强大的全球企业和联系人数据补齐企业的背景信息，快速准确获取目标海外企业的实时数据',
    _BE059F8A6DA308ED:'超高性价比',
    _E65E939E26214EAA:'报告比同行业价格更低，信息更丰富，时效性强，确保您获取低价高质的信用报告。',
    _C440E38573D0145D:'规避风险，保障安全',
    _FE739EEF3080DD68:'实时监控目标企业的信用状况，专业团队分析企业信用，助您有效排查合作风险，保障交易安全。',
    _B10630E0D8D13FD3:'客户反馈',
    _43B40D3F1F22732D:'某国际贸易公司：我们的客户广泛分散于欧美国家，借助Xieco信用报告，可以帮助我们在合作之初就全面了解海外客户，规避交易过程可能带来的风险。',
    _08B5BE7DD2CC7D75:'某电子产品制造商：我们全球有300多家供应商，由于供应商遍布全世界，实际调研和考察供应商十分困难。Xieco信用报告能帮助我们轻松获取到全球供应商的实际经营信息，为我们筛选稳定的合作商提供决策支持。',
    _F40FA0794B5CA32D:'某石材出口商：Xieco信用报告的价值在于，帮助我们在和合作之前就能够深入了解合作伙伴的财务状况及付款能力，使得我们能更好地规避拖欠款风险，国际交易再也没有后顾之忧。',
    _4CD6A108A46704A8:'请输入中文公司名',
    _BE8E294684E939D9:'我们提供的信用管理服务为上千用户解决了信用风险问题，为客户解决了数以亿计的交易风险问题，从交易前，交易中，交易后，提供不同的解决方案，获得无数用户的好评和信任。',
    _F29BF0DACABC8ED2:'公司列表(中国)',
    _2D59C19603FD5527:'公司详情(中国)',
    _591EB3EC5759E4B0:'公司列表(非中国)',
    _9BB75D9C0059F25E:'公司详情(非中国)',
    _FC3489F65384534A:'状态',
    _A1660A1A4BE5FFB8:'抱歉，暂无征信报告信息',
    _33BB118CC1BFF7C6:'未找到目标公司？试试提交自定义表单，我们为您人工查找',
    _B822D59484EAEB7B:'找到以下2种征信报告',
    _1AFDD3DBEEBD530A:'唯有信用，才有信任',
    _8753146967499F32:'征信报告余额支付',
    _63F4064ABFE70969:'以信用为准绳，助您全面了解商业伙伴，迅速作出决策',
    _653DF5A8CAA01210:'某国际贸易公司',
    _AAD9EB0E0B90CCCA:'某电子产品制造商',
    _E848C54912EC40A0:'某石材出口商',
    _CBCEEC8F25DF0115:'朱女士',
    _E1533A568DDBA971:'王先生',
    _7DBA136D2733BCEE:'张先生',
    _3499BA5DD7693F05:'去支付',
    _277941AB912CAF81:'支付成功',
    _9AE17C15C2E1D2A5:'支付失败',
    _AEC13FDCDF01EDE1:'余额不足',
    _7427F8736073413F:'订单未支付',
    _74FB3F436F1EB255:'中国公司数据内容暂未翻译成英文，下版本提供此功能。',
    _1A0F989BBBCDCFC5:'防范风险关联',
    _0CFFCCB570AC3B58:'公司地址',
    _C34725BB187861E4:'普通订单（{count}个工作日）',
    _9A394E936AF30A86:'加急订单（{count}个工作日）',
    _81BE62CD6CE166D8:'特急订单（{count}个工作日）',
    _AEA865E0CD84E93B:'支付失败！请重新支付！',
    _89A7600CA59186EE:'暂无网址',
    _BAD350CE30545BA7:'暂无地区信息',
    _98F1363FFA0DEDE2:'暂无信息',
    _FEA78BAA195C36D0:'Xieco-全球企搜',
    _A6DA3FF15AAAC41F:'搜公司',
    _34CA36149B6958CC:'搜人脉',
    _F68A25D0A8347803:'公司名、产品名、域名……',
    _A8EEDA4301C24523:'6千万企业、4.5亿联系人等待您的拓展',
    _4C84BC23E0FC197B:'创建电子名片，获取精准人脉推荐',
    _1BA95A7C35301834:'创建名片',
    _EA18C206890A8C81:'热门搜索',
    _19538F4716FBCE73:'登录并添加名片后将获得更多精准推荐，去登录',
    _81DE78B8032F1A6C:'未找到感兴趣的公司？',
    _DBD2FA5F62010533:'补充行业及产品信息，让我们为您推荐更多人脉',
    _5B392C5B70AFDDF5:'去创建名片',
    _3A9BE28F7F4A0183:'名片中添加产品信息、视频有助于客户更快了解贵公司的业务',
    _50C38898BCB9F6AE:'为您推荐',
    _6B706D82DC53B940:'推荐的公司不满意？?',
    _8E495D2BAC44DAD7:'完善关注的标签可以获得更精准的推荐',
    _EF21C34D37215773:'去完善我的推荐设置',
    _9438F34A0171B07B:'推荐设置',
    _0BA1FA8EDD805D16:'国家/地区',
    _05B9138394F3B4BF:'公司规模',
    _A8854B476402BAF7:'年营业额',
    _CCD0ECFF8EA66B08:'行业',
    _723CCE425E1DF36E:'行业关键词',
    _43249C38B053C526:'产品关键词',
    _319766795B2EA0DB:'样本公司',
    _7AAE1129E04FDEB5:'保存',
    _5A2CB47F82C68789:'重置',
    _77174ACF204D0C0A:'请输入要搜索的行业名称',
    _2388069251B4E253:'人脉',
    _AD29ED014EA5BA02:'收藏的人脉',
    _67F2F1A60FA733F4:'收藏的公司',
    _3F17028A0DB4D688:'谁看过我',
    _EE6850D8CFD141C2:'有新访客',
    _12D8E2B2C940D826:'推荐人脉',
    _D8A72A9A18DE4FAA:'您还没有完善名片，无法为您推荐人脉',
    _07FE9A67EAE94A35:'去完善名片',
    _EF26ECAFAA65F8D0:'已添加到收藏的人脉',
    _3953426EFEE247E2:'编辑',
    _6AEAC506A69E32BB:'发消息',
    _3CFD87426BF1648D:'编辑分组',
    _40BAB16E44819D11:'删除人脉',
    _ABD3BFEB90ABA621:'已联系人脉',
    _15322670FC5C306E:'消息',
    _135743FF6B153099:'搜索人脉、消息内容',
    _C75FC661D9FECCFD:'站内信',
    _717005B0750B96AE:'邮件',
    _8A540A2B7B422B04:'名片',
    _5F0FC134E152D4CC:'系统消息',
    _3F83850B507368F9:'*条未读',
    _A22C8DBA0BEFD699:'向您递了一张名片',
    _D3056B3E9BC8E069:'您购买的征信报告已经制作完成，点击查看',
    _4F315AB55395C02E:'点击发送名片',
    _C13DF50E5D9A9B38:'名片未完善',
    _8E544AE849F9B247:'名片信息不够完善，请先完善好名片信息',
    _E1902F5A973DC466:'取消',
    _9732C79D274798DB:'完善名片',
    _739C30008888F092:'我的',
    _25CA9B62E14C3817:'去充值',
    _CF7B6478555ED736:'升级到 VIP 会员',
    _CE529229D4E42E75:'VIP会员',
    _F810433E950D3566:'到期日期',
    _A889E38F1DEB4CAD:'消费明细',
    _F6124616F74790E9:'我的名片',
    _918B6BF4D1F9B0D5:'完善信息可以得到更多更精确的推荐',
    _1DA27B31FB6FB7C4:'我的推荐模型',
    _793AC7049D8DAD9D:'关于 Xieco',
    _AA8AEC1653BB702A:'退出登录',
    _F260F67BB46A09FC:'个人信息',
    _5BA120792C93CC75:'姓名',
    _C1C06DEDB67E0394:'手机号',
    _9FB1511F382D772D:'邮箱',
    _5B04EFE72FA80E4F:'职位',
    _CAB254FF0D8CE210:'编辑个人信息',
    _B710FDBE9A2B10D1:'公司信息',
    _7F6279B6099B52C2:'公司',
    _FD4CA0D4DDBA5BEA:'公司官网',
    _1A03065EFE5A6926:'公司简介',
    _A3AAC2A75B7C1FA9:'公司标签',
    _275CC5A9280A5A1C:'编辑公司信息',
    _38DB07404F1DF098:'公司产品介绍',
    _357D8ACDBB351CD5:'未添加产品',
    _EDF0091560C61D79:'编辑公司产品信息',
    _43574CF7DA001080:'产品视频介绍',
    _091359354AC11B13:'未添加视频',
    _CC5837568DEC5C96:'编辑产品视频信息',
    _57BB22A10B008686:'添加产品',
    _B3382463A7AA33FB:'添加产品截图',
    _7D485EDCDA2AAEC4:'产品名称',
    _2A8F9B236FD83253:'产品链接',
    _57653428E14F7782:'产品描述',
    _DA93D395C597AED9:'添加视频',
    _A86253C9AD264BB0:'添加视频封面',
    _7F2AEE58090222DD:'视频链接',
    _D0A1658F85795188:'可将视频上传至优酷（英文就修改为 YouTube）等网站再复制链接',
    _B7B0000677FD9B91:'视频标题',
    _4D4DBE29D29D2128:'请输入',
    _23FE82ADBBDB53E9:'名片被查看记录',
    _59F4B0CD43E5ED83:'您的名片还未有人来查看过',
    _942AC6ABE5549AF3:'完成以下两个步骤，助力您拓展更多人脉',
    _9B50D5F98086DB11:'完善名片信息',
    _BE45D0199CAB4A95:'发送名片',
    _3001A883DD2E74CF:'陌生访客',
    _537549EA6D49FC0B:'访问记录',
    _FDF1EF9B8C8C8E9E:'访问时间',
    _BA9DD426B20A0DB0:'微信支付',
    _89C85EF2AC06B18E:'支付宝支付',
    _DA45B7D8378BD4E4:'确认充值',
    _CFB15065868CB5D7:'升级到 VIP 会员，解锁更多功能',
    _1EF1936B851136A7:'普通用户',
    _C0D91E4F1F776D1B:'VIP 用户',
    _597464741724C2AD:'查询结果显示条数',
    _72DC2E074553CD2F:'数据导出',
    _9BA58BB7F51B4CA9:'公司基本信息：地址、电话、经营范围、网站等',
    _9120200E6800DECA:'高级筛选功能',
    _B65E5F6CD2571DDF:'国家区域、规模、营业额、行业等',
    _C7286B64327DEBBB:'闽ICP备2020019984号-4',
    _0D62E92D0BD3A446:'未搜到企业结果，换个搜索词试试？',
    _1CB107827EE006CE:'填写目标公司信息 ',
    _0F006942431FDBEC:'填写目标公司信息 以及您的联系方式',
    _A1624725A9FD0F0C:'预付报告款',
    _3714801E3889185F:'等待报告生成',
    _78097239AD02A903:'如何获取目标公司信用报告？',
    _9CF23A3BC6F6ECEF:'11国即时报告：英国 法国 德国 美国 意大利 爱尔兰 荷兰 比利时 卢森堡 挪威 瑞典',
    _AE275BC6C2D12362:'游客额度使用完毕，请登录',
    _12F1CBE93D6BEF0A:'全球企业尽职调查',
    _65343CB79BC5A3DD:'帮您快速尽调企业资信，分析您的竞争对手，推荐您的合作伙伴,达成高效安全的交易',
    _5F3C67AF1D997218:'全球企业人脉推荐',
    _596B3FE0D4FD3C03:'帮您快速找到企业人脉，推荐合作联系人，达成快速安全的交易',
    _54D1A8EA08E80735:'对不起，获取TOKEN失败',
    _AF6DC5BCA6B96CAB:'注册验证码',
    _49B1C04E04567211:'邮箱绑定验证码',
    _E2DDA9D62F258EED:'关键词不能为空',
    _1A3126B313DC9692:'普通会员只能浏览前十页',
    _CFA7C6E4FB09D9F2:'额度不足',
    _DEEC0FAABA4C33A0:'获取联系人失败',
    _A43B950B31ED3CF1:'获取公司失败',
    _C1010E70CC0EA895:'参数错误',
    _B2ED798DE5151645:'操作失败',
    _D1CAE6C1D71C76BE:'不能与自己会话',
    _53987E59B7E0A849:'链接格式有误',
    _A0B1983ED3F622A9:'昵称只能输入50个字符',
    _B8B41ABE269C9E75:'姓名只能输入50个字符',
    _6EE6826FD0533EEE:'公司只能输入200个字符',
    _C81ADC5C2D9C0BB4:'职位只能输入50个字符',
    _1D8CE6C009EB18B6:'地址只能输入200个字符',
    _2F620189723F1534:'查看全部',
    _50CE5624B31AFDE2:'还没有该公司的主要人员信息',
    _88EB55B8475184EC:'还没有该企业的新闻信息',
    _3CB86ACDFACDC2E9:'还没有该公司的知识产权信息',
    _E17C5ECB110E0FE4:'还没有该企业的招聘信息',
    _28B54BEA107EBB8B:'还没有该公司的股东信息',
    _8D69591B29180004:'购买报告',
    _B20E22C52E12B1AA:'查看全部域名',
    _559276D58F3A9973:'至',
    _59BA909400B60C9E:'工商注册号',
    _D45C5F9EC04ABB48:'还没有该公司的企业年报',
    _9829CA6937637ABE:'确定要删除该企业?',
    _1B2B292E4E793C9C:'确定要删除该联系人？',
    _D2E47AE7C6D4E04D:'快去搜索公司吧',
    _9D904A4A90D6BEB0:'快去搜索人脉吧',
    _C2584632CFC3510B:'没有收藏公司怎么发展业务',
    _1E5E80544E3B88D7:'没有收藏人脉怎么发展业务',
    _4D02C4BDA664C102:'该关键词已经存在',
    _7AD2BC5A881630B8:'请输入样品公司',
    _97811B1C0A748E7B:'请输入行业关键词',
    _EB6249E409300659:'请输入产品关键词',
    _38F80563867C1563:'不限',
    _38AFB5DF36907ADD:'清空记录',
    _79BE6EDA26BF8D6D:'清空搜索历史完成',
    _6D6633ACA71AFB07:'分享至',
    _C4163A3C500B2F37:'请使用浏览器的',
    _E17E20A3F83F4737:'分享功能分享到微信',
    _6C087EC792D87414:'知道了',
    _9D4C8A1B173382AA:'马上添加',
    _93BB8530DA5A9C75:'输入所在公司获得更精准匹配',
    _9B3A9AD93CFB6409:'换个搜索词吧，不然我什么都找不到',
    _E3D99ADB6C72379A:'没有可以筛选的数据',
    _61271625D42B0EA2:'产品关键词为必填项，请勿全部删除',
    _BFC83DB6CC145967:'请输入中国公司的中文名称',
    _16CC3AC457CCE4AC:'查看邮箱',
    _2E761A17033BEF70:'请选择要查看的公司',
    _9D9D62A53D9C5CC4:'企业画像',
    _1412A718B3127FF6:'相关公司',
    _703FF40A143C4F8B:'我来补充',
    _3F0ACACE701EB05A:'主要联系人',
    _C6B4B818DF375C38:'还没有公司的同事',
    _1F6993CAD3B3306D:'还没有该公司的公司简介',
    _6454BBE8C42A58C6:'还没有该公司的企业画像',
    _23732EEA1F108F83:'还没有该公司的新闻信息',
    _FF4A16D3A35A2FD6:'还没有该公司产品的信息',
    _4E55E107121DDE2B:'还没有该公司的社交信息',
    _524A5F08E086A2C6:'还没有该公司的视频信息',
    _40995FCA6E433A67:'还没有公司的相关公司',
    _C72F446DDC5B39A4:'还没有公司的征信报告',
    _0F65F29A1B393020:'还没有主要联系人的信息',
    _B6F90EA7B4179959:'专业征信报告',
    _92A07363E0D9CD5B:'标准征信报告',
    _35F89CCD40862F62:'删除后该分组内的人脉将移到默认分组？',
    _66399285087F7F49:'修改成功',
    _6A130A192F26B4DB:'5次/月',
    _2466F37F275D60D2:'数据覆盖全球218个国家和地区',
    _D77FB1C0C64A81C3:'可多选',
    _6CCBBB51F80666CF:'社交帐号',
    _71ABF8439D561DF2:'不排除',
    _BD1B321EF1897552:'非中国企业',
    _21535E03C95160AD:'正在根据您设定的条件检索相关客户',
    _AF6134C248F67FAB:'请选择国家/地区',
    _650C09FEB763D570:'请选择行业',
    _FCE84B705C7FA099:'请添加产品英文关键词',
    _38787358E95233BF:'开始推荐',
    _5F6B537122D4444E:'提供以下信息，让我为您推荐潜在商机',
    _0B13C130A6E126D1:'产品关键词为必填项，请重新编辑！',
    _985C17DDE0E4E37F:'该过程可能持续1分钟，请耐心等待',
    _25855C63A4784ABA:'搜中国公司',
    _3779A04EC830D6AB:'搜非中国公司',
    _EDAC839AA3DD6515:'根据您设置的条件为您推荐',
    _FD74E6FFE4DC8697:'岗位',
    _8EECDE592A70EC2E:'级别',
    _6A5CF4BE7CB326F5:'使用筛选功能需要先行登录，是否前往登录页面？',
    _EE05CBB70DE153A4:'筛选',
    _A0958567B3A0CCA2:'想获得更精准搜索结果？',
    _AB1EEE5BF6C5A91F:'获得{count} 个结果',
    _C4F4084C31F54F02:'智能排序',
    _917ABA70742BA520:'查看报告',
    _9252D22E454D8782:'主页',
    _23C8B7E8887D8C72:'专属客服',
    _9C2B2D7A43D0A072:'通过邮箱找回密码',
    _CF8D2623F2556134:'请输入正确的邮箱地址',
    _0582F9C340B60DE8:'请输入正确的手机号码',
    _9B031F04C4279884:'发送验证码',
    _A3E23EA97F8EEBC5:'已发送',
    _95B1BD0E489AD4D8:'请输入手机验证码',
    _FA2FF9E7AB2D8FB6:'请输入密码',
    _FB7124170D9D8469:'请输入手机号码',
    _478D82D23C19B667:'请输入邮箱',
    _B801B649A6E6CCBC:'facebook账号快速登录',
    _F01C21183D04FB87:'linkedin账号快速登录',
    _38329EDBC3E9E899:'twitter账号快速登录',
    _E272C9F65D24A6A4:'微信账号快速登录',
    _5726B3CE743958AE:'手机验证码登录',
    _DAAA7C74116084DD:'获取验证码',
    _CE5B5F49C2B88103:'释放立即加载...',
    _1CD3AA2CD48F6A49:'在此填写您想要发送的内容...',
    _81F797A1DDFF5EDD:'下拉加载更多...',
    _664C820267A734D6:'订单类消息',
    _E82B1822DF79A07C:'没有符合条件的任何消息',
    _11D7417368BA147F:'绑定账号',
    _2C23A15ADA54F02E:'联系我们',
    _D2F62B201C5B9A7A:'全球企业背景、人脉信息搜索平台',
    _22479F2FEAC8E7E0:'请输入公司标签',
    _B5291DD2F01BC65F:'添加公司标签',
    _09873FBAD0B9F686:'待管理员审核通过后才能展示',
    _6259F53E4B5CFEC7:'保存成功',
    _AE3E59176C3B1389:'会员额度外花费',
    _ABBA1189C59FD5BF:'总额度',
    _1371EE4BA960DF94:'使用次数',
    _9D826D9CFF36AF01:'申请日期',
    _6578FA0F46601CB1:'与国内外多家专业的信用机构深度合作，辅助自身强大的全球企业和联系人数据，报告维度更广、权威性更高',
    _CC460B86EEF36CF8:'与国内外多家专业的信用机构深度合作，信息来源更及时可靠。',
    _1371C77138ED9AAF:'商务部背书，与中信保深度合作，信息来源更权威可靠。',
    _5B1236067DD84713:'点击了解更多',
    _26C744CF786A25FC:'查看征信订单',
    _22747DA2A2747895:'无征信报告订单',
    _A612B96531F231D1:'当前状态',
    _7E80D8F7ADA852BD:'融合多家第三方专业机构的报告及授权，报告覆盖面更广，信息及时准确。',
    _95C0C7F12341FFA2:'申请征信报告',
    _80C62F890C02F431:'报告够权威',
    _6DE542B953C37BC1:'报告来源',
    _6E69DDCDF84B67A8:'头像',
    _F84707B16E88FF4F:'请输入公司简介',
    _55AF2BB7CFA6BECB:'请输入公司地址',
    _CCA8492573EEDEE4:'请输入公司名称',
    _E5045AC26D916EC8:'请输入公司官网',
    _8FCF84D29F9440B4:'请输入手机号',
    _A041312AD39734AC:'请输入职位',
    _24766E81F40FB409:'请输入产品名称',
    _6E81ACABF997F07C:'请输入产品链接',
    _BBA525751F12547C:'扫描名片，导入名片信息',
    _F3F10B0F0BBE9018:'请输入姓名',
    _87F56D6DDE8FF2F6:'请输入视频标题',
    _D249629C857C5956:'请输入视频链接',
    _1FD463EBDD1452CD:'请输入昵称',
    _E9F8F758E2324B3D:'合作意向',
    _4EA97E5CCC763FB7:'请输入合作意向',
    _145D3B50F1C65623:'请输入产品描述',
    _DACD26E1E0197D64:'去续费',
    _DD878D978E31EA06:'确认退出登录吗',
    _FF0AF67F625735F0:'完善度',
    _CEA635073460701A:'欢迎！请登录',
    _B75001EE26EA6ADA:'添加标签',
    _19E56442F3554017:'优质客户更愿意通过公司信息了解你',
    _C2A75AF02C38DC7A:'产品信息可以让客户更快的了解公司业务',
    _3FD16FA1F35EFB40:'产品视频可以让客户更快的了解公司业务',
    _BFFDA1865D21A913:'请选择支付方式',
    _ACAE32A8C1463483:'请输入充值金额',
    _30C93B4C2CE8655A:'选择国家（必填）',
    _204A8B0DE1C7A516:'是否选择余额支付',
    _08A891FA115F2C88:'填写您的信息',
    _20B8D1FFA26B2F95:'基本权益升级',
    _746A2FEF796B2FD4:'确认购买',
    _5CF0D4FBC45C250D:'购买VIP将从账户余额中扣款，是否确认购买',
    _438F9E43E1A959C3:'VIP用户可享受更多的结果与内容',
    _8466CFC1BDE2C800:'购买VIP将从账户余额中扣款，目前您的余额不足，请先充值',
    _DF3E6ECCA3A60FE9:'余额不足，请先充值',
    _AEAE097E13745073:'购买VIP会员',
    _C6538AFEC03F24C1:'你的名片还未有人来查看过',
    _D79B54A98B79B8C1:'位',
    _7D5F4999A5CC827A:'去设置推荐模型',
    _4E6E7F7BFE8169B8:'新增访客',
    _31F795B5F41A9FE3:'您还没有完善推荐模型，无法为您推荐人脉',
    _32104946EBB960E2:'马上切换多语言',
    _A70FD084FAEC443A:'按月购买',
    _8C96E30C670B5891:'按年购买',
    _456688C99252FA2E:'解锁更多功能',
    _64D5C8673BB8F01A:'如何设置推荐模型',
    _4730CCE1B79DE2A5:'保存并开始推荐',
    _7DC9B5653A2BD35E:'1.选择您目标企业的国家/地区～',
    _746FDCB27867BB15:'2.选择您目标企业的行业～',
    _8BDB857A37668BD2:'3.添加您目标企业的产品关键词～',
    _1E215EEF39167C20:'向左滑动查看如何选择国家/地区',
    _5362CF90FF87E4F9:'重置/完成',
    _2B68D86CBA3FB874:'选择国家/地区：',
    _256DA7250214A80E:'您可以点选目标企业的国家/地区',
    _3B188C8DF30F1D2F:'也可以直接搜索～',
    _17C24C6A224F3C4D:'「选择行业」的操作相同！',
    _AB0335EA03C29B9C:'返回/添加产品关键词',
    _F1C35B3B683375F7:'在下方输入框内输入相关的产品英文关键词，保存进行添加～',
    _5413A3E4E1642701:'公司/人脉',
    _50BD2620868A8B1C:'主页/人脉/消息/我的',
    _B9B2253A4EBA87BC:'完成前面三个步骤后 ',
    _3B3986650C937A95:'耐心等待1分钟',
    _1DD1D5C11026B486:'我们可为您推荐关键词相关企业～',
    _106DB61026A0791B:'立即设置推荐模型',
    _1ABDD4D64F5C0C42:'填写信息',
    _4166A621A795BC84:'昨天',
    _3595C580A9AB0285:'上午',
    _CA09B3665287F4AA:'下午',
    _AFADF43F52FB6905:'请输入正确的官网地址',
    _E68B2261EE8E6899:'您提交的公司产品认证未通过审核',
    _A7CB86092D86DFB1:'公司产品认证',
    _98208C886D54F363:'公司视频认证',
    _AE5564A6CA1DB1E2:'您提交的公司视频认证未通过审核',
    _47212B2A31F7346E:'递出一张名片',
    _C1E0E527F26F1D2A:'发现商机·拓展全球B2B客户',
    _B17BE4E8AD3C9E02:'推荐优质企业',
    _7CCED0C7AD9BF19F:'提供以下三种企业维度，让我们为您推荐商机',
    _2459C97CE64348EE:'提示：输入人名或公司名都能搜索到人脉数据',
    _3DD7B3335FE19E1F:'您的游客额度不足，请登录获取更多额度。',
    _3C5EDF0F9B015F4C:'您的免费会员额度不足，请升级VIP获取更多额度。',
    _DB3D9F850AADE4C3:'10M以下',
    _735F419348184BE2:'500M以上',
    _2D87D57A021E8E69:'您提交的公司产品认证已审核通过',
    _58168CD3BA104F43:'您提交的公司视频认证已审核通过',
    _F833A80FD32FEEC3:'您提交的的公司上下游已审核通过',
    _925FDE7C6A030B21:'您提交的的公司上下游未通过审核，请修改后再提交系统审核',
    _BC5AF4CFD36D9016:'您提交的的意见反馈已审核通过',
    _A82AA0B54FFBE49B:'您提交的的公司认证已审核通过',
    _9EDEE033649A56DD:'您提交的的意见反馈未通过审核，请修改后再提交系统审核',
    _53FFBC95D195CF41:'取消成功',
    _2CA848FCBD770722:'为必填项',
    _312ACAD1FF0A39A4:'格式不正确',
    _7169151B41C5BFF3:'最长不能超过200个字符',
    _EAC4C57052393977:'最长不能超过3000个字符',
    _EBAAE2755D3574F5:'联系人没有邮箱不能进行消息发送',
    _E426FF53CFFAF916:'请先输入正确的邮箱地址',
    _27DBF999E04B540D:'请先输入正确的手机号码',
    _2503845CE8F283C4:'抱歉暂无推荐结果，更换或添加产品关键词能获取更多推荐',
    _923244C0417432E4:'输入英文公司名，产品关键词，域名',
    _C2C5D7C90EA01220:'输入中国公司名',
    _37D5D1B1DB2F8FC8:'分享自Xieco-全球企业尽职调查',
    _6C604C8A149EA289:'我是{0}，这是我在 Xieco 上的名片',
    _E967F89720749A17:'头像上传中...',
    _1395F408DC9CCE9D:'输入公司名获取更精准人脉',
    _9047BDF14CD8BF48:'名片识别中…',
    _CE91A176EC28536D:'名片信息有误，请重新上传',
    _EE333F1C4AECF8CF:'账号绑定成功',
    _E9FEC2CAD1376BD7:'1.完善名片',
    _A5868E08463269CD:'2.搜人脉',
    _71373C2177B34D12:'3.发送名片',
    _FA55F7DA5BF4852E:'目标公司地址',
    _3B7AEC1AD6F14885:'目标公司联系电话',
    _6072A3E91A3740F9:'您的公司名称(必填)',
    _1DB9ADC2536CC2F8:'系统语言切换成中文',
    _B526CC68B431E731:'请添加行业英文关键词',
    _1457C9D1A51E05DD:'请添加样本公司英文名称',
    _7AD0DF1E3558BB99:'登录',
    _33DD0B9E0A03119F:'注册',
    _DE45166EE6F9CE16:'忘记密码',
    _006A08FB0A747BFD:'会话详情',
    _6D3438C37E417B7C:'搜公司-筛选',
    _96D58E47CB7EEDA1:'公司-详情',
    _93BBD91700D155AB:'国内公司-详情',
    _0CDF68EF62DF195C:'国内征信报告确认页',
    _F248A7347208F73D:'推荐模型-引导',
    _D7A6B05D1BBE59B6:'查看更多',
    _228B992F75D4FF9D:'搜人脉-筛选',
    _2EC0179AA78987A4:'搜人脉-详情',
    _7A370DAF7979B9E2:'产品-详情',
    _9C4A6D7B55EC4D38:'设置',
    _542854D02CE4D2BD:'升级到vip',
    _0F1CDB7EAD42C0C1:'我的名片-分享',
    _3D458DCC79E1D49E:'浏览记录',
    _D2C9E019EFCCF118:'收藏的联系人',
    _CA544D73C2BEE0C3:'关于我们',
    _8E4C5C76E365466D:'编辑基本信息',
    _D6629A08950AF142:'添加产品关键词',
    _2E92CCA6F13BD294:'添加行业关键词',
    _DDDE8D06F0BAD418:'添加样品公司',
    _CCC241E1DB1A9CFE:'非中国征信报告确认页',
    _1F05AB5B4617520D:'20家公司/月',
    _1D91425FA83D8B22:'5位联系人/月',
    _58CBB215C0205A86:'200家公司/月',
    _BAF67580FA843F02:'2400家公司/年',
    _D6EE4F85B5B243F7:'20位联系人/月',
    _FB325EB1EAE575BE:'240位联系人/年',
    _CFE0B4E045DE68E8:'?4788/年',
    _D2C82D8E772C3110:'￥399/月',
    _7B1F66AD23E5BBB3:'联系人无邮箱不计数',
    _F2715239824AC9A8:'当月VIP会员特权数用完后，可充值余额继续使用',
    _C162E28BF9E5D023:'说明',
    _B0ED9BEF1EF26A92:'邀请码激活',
    _5775636DD32E6736:'激活',
    _4257BAF75814866B:'未激活',
    _4ED72DE9E7BA3BE5:'单行输入',
    _D73DF50151F45ADD:'您的帐号',
    _A1B697CE43E52034:'渠道验证',
    _BC236D2941487EED:'已验证',
    _0CBC920BD1D92A9D:'您的邀请码',
    _728EB0049CE09AF7:'邀请',
    _9CE4635E4A8FDE2B:'您的邀请',
    _F053A00F03AAE978:'注册用户数',
    _F79C14A1E14CB74D:'付费用户数',
    _7C2DF48B87951558:'提成记录',
    _E02079F5DE6C8A0D:'提成说明',
    _85334F574AEE7D72:'当月提成金额',
    _5B32BC308E8A36EA:'总提成金额',
    _34DDDFCE59B16591:'历史提成记录',
    _1B43DD105E94DC0B:'验证',
    _335DFEAC048E42E6:'渠道首页',
    _6BD18044F5CDB307:'付费用户列表',
    _62BE7862DC05E477:'注册用户列表',
    _23C18B187F28FDE3:'渠道登录',
    _B35AF34E026EE73A:'渠道注册',
    _6026301229759FD0:'渠道忘记密码',
    _CD055FA2BBA89255:'邀请您加入Xieco',
    _8F4983ECD8641126:'使用邀请码注册',
    _1BD1BC6BB5D9D792:'使用邀请码登录',
    _4BDD9A2BA697DB90:'您未使用邀请码激活，是否放弃激活？',
    _47C461DE810A8E28:'该验证码已被验证，不可重复使用！',
    _C81768AB3CE0FE5D:'您的VIP体验会员额度不足，请升级VIP获取更多额度。',
    _907DFF9D49C512B6:'验证成功',
    _2A6602F7ADE96B65:'VIP体验会员',
    _4999DD23C9B4969C:'验证失败，请校对验证码',
    _C946C49D58E4948E:'邀请码错误！',
    _98F69A268185AFBC:'您已是渠道用户',
    _0AF9F342E850E45B:'激活失败，请校对邀请码！',
    _426732F635E5C92B:'提成金额',
    _C8CDD849E20AD8F1:'您有待提现金额，请',
    _1E68E1F546349DC5:'联系客服',
    _D5EB594926AB3E7C:'你还没有任何的提成记录！',
    _F5060CDAD153F42B:'拨打',
    _A3BA3419078A6C22:'您的账号已经激活过了',
    _CA12E8C438AD2B68:'未提现',
    _FFC52BC27D3B66D5:'已提现',
    _0A3BC336CBD8ED20:'验证失败，请校队验证码',
    _105B1A402251877B:'渠道佣金说明',
    _142A42E47A6A15C0:'没有任何用户',
    _6559215FDB326398:'提成比例',
    _FD04666F6CE71785:'1.DD推荐帐号及征信报告提成制度，采用现金计提方式，',
    _1276F955F5E503F2:'2.推荐帐号合同的提成基数以实际到账合同金额为准。',
    _8BA372923BBE5542:'例：客户通过邀请码可获得200元年帐号优惠价，渠道销售可计提1200元年帐号。',
    _396B1676E6054F05:'        客户通过邀请码可获得15元月帐号优惠价，渠道销售可计提80元月帐号。',
    _C0201275B4F60B07:'3.征信报告提成按每卖出一份海外企业报告（含专业版及标准版）得50元优惠，国内企业标准报告得50元(国内非企业标准报告不参与计提)，渠道销售可计提100元。例：客户通过邀请码购买海外报告可获得50元优惠，渠道销售可获得100元现金计提（国内非企业标准报告除外）。',
    _BC9F61F237C14488:'提成结算',
    _6BBA574C6677084A:'1.结算周期：按月结算（另外会有提供渠道统计页面计提）。',
    _DFD40F8952ABA1F2:'2.提成发放：提成结算只结算已到账的金额提成比例，未到账的合同金额提成不予结算。具体按照渠道统计的到账金额分成比例每月结算，确认无误后于下月与当月薪资一并发放。例：小明1月份截止到月底1月31号为止，渠道统计到账金额为2600（年推荐帐号优惠价）*20个帐号=52000万元，累积可获得20*600元=12000万提成，则小明1月份业绩提成1.2万元将于2月16日（薪资结算日）发放。',
    _B75024CC56B14692:'其他说明',
    _FBA15BC2DEA7A3DA:'1.渠道人员若有损害公司利益、欺诈公司及客户行为，未发放的提成不予发放。',
    _6482D8FAB21B320C:'更多维度获取精准企业数据',
    _3A85B6B0FA45F1EE:'Change to English',
    _3C398E83EE740BFB:'请输入邮箱或手机号',
    _97E4540DDFAD303A:'返回登录',
    _008DC10B30A15469:'展开',
    _1F0A183A6F70F528:'产品',
    _64C64F83252BA697:'视频',
    _3792D195E0C700C1:'请输入国家/地区',
    _B544528A0A0E4713:'完成',
    _8B1F09E0F1E87CDD:'查看联系方式',
    _3346E48D36F8380D:'其他金额',
    _EC32642CD78B5A82:'充值金额',
    _B3C7F51625BB72DF:'第三方快捷登录',
    _D8B6AC08C2CD0674:'渠道申请',
    _A6C4DF4674B975D0:'我们会在1-3个工作日内联系您',
    _3EE1246CAF9656BC:'渠道政策',
    _364CB3CE0194210F:'立即申请',
    _2B0A1353976366BF:'请您输入有效邮箱地址',
    _6E92C1509D8C851B:'您的申请成功提交，我们将会尽快处理！',
    _56DC7C19341797D9:'邀请账户优惠',
    _870E0F560ADB9AA1:'请输入人名进行个搜索',
    _E0E830573707B40A:'请输入所在公司获得更精准匹配',
    _85B3B1240C062DB7:'提升销售效率',
    _85D4FC75449B174A:'提高投资回报率',
    _916C2C486DE99AC8:'招聘更快更有质量',
    _C7D90ECD6D254CC1:'精准找到您的客户，让Xieco帮你链接到更完整更精准更实时的商业联系人数据。',
    _0779D3CB7FF6C398:'提高您的市场营销投资回报率, 完整的联系人列表让您精准地找到目标客户，让您的营销内容更击中目标。',
    _5BF50D7DC6CADD5C:'不用再花费太多时间精力在不合适的候选人。Xieco通过地理位置、岗位级别以及行业筛选让你更好地找到目标候选人。',
    _344FD45EA2EE5E03:'更快找到您的客户',
    _5CE0A4B3BC8107A7:'全球1亿+企业数据全面呈现',
    _C7C9B431C00826A2:'企业数据',
    _66D1246A0FF85CF1:'二级行业',
    _E013FC93453F0442:'获取报告',
    _0A8C7B53565DE4F4:'个',
    _1AAF2B8BC38FD923:'百+',
    _AB08C4D999BBC98F:'秒',
    _39DA9AF2424004D3:'征信报告优惠',
    _23D438DAD266872D:'您确定放弃支付',
    _68A74FF668CE7E34:'您的账号请输入邮箱或手机号',
    _5A2E90BA67ECCC51:'政策说明',
    _571EE0F5A5CDE070:'1.渠道人员若在申请成功后，一个月内未完成5个VIP邀请订单或20个注册用户，则取消渠道资格。',
    _990EC6181F88582C:'已回复',
    _A0C9E3866113F49A:'已读',
    _E8875FC27ECE4137:'消息送达',
    _BA41D31BCBE087C8:'消息发送失败',
    _0F5EB8EB13231C8B:'完善个人社交信息或手机号可获得查看5个联系人及10家公司详情的权益。',
    _19244C36B08E82F7:'立即完善',
    _B13168073E9CA5E8:'您已注册过账号，请登录',
    _38762453AF5C0B8E:'以下11国提供实时报告：英国，法国，德国，美国，意大利，爱尔兰，荷兰，比利时，卢森堡，挪威，瑞典；其余国家需在线提交报告申请。',
    _DC6B0ED504FAA4E2:'注：',
    _D5B32478DB2D6591:'立即联系',
    _51B30CD35F8DC015:'请在vpn环境下使用',
    _CD6469AB08E74D3C:'您好,请查收我的电子名片，很期待与您进一步沟通！',
    _602052E989EC072C:'您的账号已经被绑定过了',
    _B00512B810F41BD2:'订单已支付',
    _24DEB4D85383A60A:'招聘推荐',
    _EB6F0CAEC548EA0E:'商机推荐',
    _B6B0759CDA8CA898:'最多只能添加10关键词哦',
    _3001F626F2E1CF62:'确定要删除历史记录',
    _A7B26DFEE1F3446A:'如需更换推荐模型类型，在设置，模型选择中操作',
    _FBE1BA6C807D22CA:'获取商机线索需要您填写以下模型信息模型尽量详细，我们会为您精准推荐。',
    _8E930E0F8DB22FCD:'获取应聘人脉需要您填写以下模型信息模型尽量详细，我们会为您精准推荐。',
    _07B69FC78B63B242:'暂无关键词',
    _9B70996C4B1B3131:'搜索公司人脉',
    _5271CA1D819B0F25:'B2B销售线索推荐&预测',
    _E590E3630FC9EBE8:'访客实时跟踪 与潜在客户即时沟通',
    _A50EB7F005B5762B:'全球信用报告助你规避信用风险',
    _C4BF7A8EE279F260:'选择一个推荐模型',
    _D2B8D4A2C1234C1D:'我要找商机/合作伙伴',
    _6E228FBD5934C8A0:'我要招聘',
    _E68B097F9DC1C108:'开始',
    _23C34579B6A6FCEF:'历史',
    _B8C231B0DCD9E1B8:'高级',
    _60DF9C64E3FE3A60:'高级搜索',
    _EC733607091B1EFD:'标准',
    _1A594C595C4CBAB9:'关联推荐词',
    _037055B2B47563D8:'首页显示10个关键词',
    _43AFE88DE60C66AB:'正在为您准备推荐数据，请耐心等待',
    _3D6E79FB296D1D0B:'热门联系人',
    _0BC89403D10CACE7:'完善个人社交信息或手机号可获得查看5个联系人及10家公司详情的权益',
    _49812C7632A5EEE9:'通过手机号找回',
    _F37CF06F2CE9B91C:'请再次输入新密码',
    _173F2CA1EE16789B:'请输入新密码',
    _2B834EBD7B7C6276:'下一步',
    _3F2C632FFA3E59E1:'您输入的两次密码不同，请再次输入！',
    _D11A567143E9A9AC:'修改密码成功',
    _DAA57F5B1AF692A9:'发送失败',
    _BDE330FB38F28429:'聊天',
    _24FBFBCFEE41BD22:'访客',
    _B6A12CBF4387FF90:'您的名片将在聊天中展示',
    _B473B58DE25D5056:'更换公司',
    _C5594F009A1C7922:'创建公司主页',
    _85B4D0A928ED1C07:'请填写您的真实公司信息 一起构建安全可靠的商业环境',
    _883CC3AB1876E58B:'请填写公司基本信息',
    _1143FE11B3874EAD:'营业执照+名片认证',
    _3506DEE0113100F2:'营业执照+工牌认证',
    _FE2F68D0FA8FD635:'暂无消息',
    _46D8C487AD18F3C3:'访客记录',
    _989FAEC49947CEB1:'名片信息获取成功',
    _3125ADF7FCF2867D:'次',
    _FD51235D88CD881B:'该类人脉已经读过您的消息，请优化内容连接他们。',
    _D617EBCB61969AB1:'消息已送达但未被查看，您可以通过社交或其他方式沟通。',
    _9FD8C5F13D6E6BC1:' 消息发送失败，不耗费额度，您可以通过社交或其他方式沟通。',
    _04183984276984D4:'续费VIP',
    _02DAAB5934951409:'商机模型',
    _2A873EC2F3295FDF:'招聘模型',
    _5E384C4CAA6AF200:'需重新认证公司，谨慎更换',
    _2EB147ABD2391214:'审核中',
    _69DAF4311E328D8A:'高级认证',
    _99A0F50EDF22548B:'审核失败',
    _F7FD28AD0F1608FA:'企业材料仅用于企业验证，不对外公开',
    _6EE80D4996DA7078:'详情',
    _2980CE3BCC0AC070:'需付',
    _E7BA9E7EA2658238:'退订失败',
    _DE707CD54B99CBD7:'退订成功',
    _7A435CE271D63983:'加入会员',
    _AB23295581549C92:'请上传营业执照',
    _B58A5B6D0E75A74A:'手机号码立即登录更快找到您的客户',
    _557F966963A16453:'创建新账号',
    _A4F94C004E367D0B:'还没有账号？',
    _B8B47AE5C4400C78:'马上去注册',
    _449832D39D28AA3A:'使用密码登录',
    _873A6BA26DF61FC6:'对不起，该邮箱尚未注册',
    _A4F5EC59ED740333:'我们已经给chen@socialbird.cn 发了一封邮件，请注意查收',
    _DCD1721D31CB694F:'请点击邮件中的链接重置您的密码',
    _6256654FB5E8D544:'其他账号登录',
    _1A773E94D8F3CAAC:'我的公司',
    _6A830108A01B2D97:'我的岗位级别',
    _1353CD0B48B0F4DD:'您的微信号已经绑定过账号了',
    _44817BF07F086A37:'您尚未认证公司，请填写相关信息提交申请',
    _CEC257C6291C92B6:'我的D币',
    _1F1D8ABD4002687D:'<span>{count}</span> D币 将于 <span>{date}</span> 过期',
    _4E32676F63C9E983:'D币规则',
    _EE962E7A6A575C03:'D币明细',
    _CFB36049B6C0AFF2:'D币收入',
    _8434ABDE22B5CDFA:'D币支出',
    _18BBF1BA230531D3:'D币变化',
    _3753645B7E1421F0:'日期',
    _AB57A2867860BDA7:'兑换额度',
    _F8EAB2F697012CC3:'D币',
    _03CB969AC82E256D:'全部时间',
    _2F7EA45FFFE3181C:'<span>{count}</span>天内',
    _9D1E460B92E22023:'暂无数据',
    _AEDAE9AA4984C8B8:'您当前有<span>{count}</span>D币，请选择兑换类型',
    _AE49597094535F9F:'查看联系邮箱',
    _51FBAD1C42AFD5EB:'查看公司详情',
    _BECD660987574F5B:'查看个人社交账号',
    _6DF63609E350EC0C:'消息联系',
    _6111BA178DA62D1C:'D币/次',
    _052A0572AD3F7107:'兑换类型',
    _95EE555BF0D4A5C2:'兑换数量',
    _229340AC51ED1E20:'合计消耗',
    _2893BF26F891AF67:'升级流量包',
    _B376BF217A597938:'上一步',
    _588ABF7E3B9A28F1:'确认兑换',
    _2DC2F8692A286619:'30天内',
    _55016D5872745BF5:'180天内',
    _10167B6FCDFB782E:'365天内',
    _68A3995934AA02F8:'Xieco VIP服务全面升级',
    _3BEB5EC9C32B7A65:'专为商务精英定制，精准快速联系目标关键人',
    _D9BB9ED51C92E839:'了解更多',
    _31B0C07D0ABB4E8F:'万里查数据',
    _B31F27737A686C25:'请输入产品服务关键词或公司名称',
    _B749DD2A72BF6407:'1.4亿',
    _F0D11BA2F72BB2CA:'行业分类',
    _BC4272E4C431DE9F:'人脉联络',
    _4EA87CA412FA79DF:'Facebook',
    _7CB2DDE1CD40D2E0:'30秒出报告',
    _B8B856AC398A7A72:'全球企业信用认证/催收/保理',
    _8B2AD073CEEAD54B:'全球216个国家企业联系人数据',
    _D8F70929024671D0:'公司目录',
    _70733CDD441F8C4C:'按名称浏览',
    _43FAE2C94CB9821E:'全球贸易企业的人脉社交工具',
    _77AB7CF8BD0F86F4:'获取10000家公司信息，每天仅需2美元，点击立即购买',
    _65264915D1AA9096:'Xieco VIP会员流量包价格及权益',
    _96EB1A2D0D319711:'流量包类型',
    _FA772CEA3872929C:'流量包价格',
    _7FA9A44BCC6E780F:'流量包使用有效期',
    _23E21AAFCB529692:'同时在线',
    _590F8043B545E3BF:'会员权益',
    _F29C5F7F4BD6E42D:'月流量包',
    _4D1922E6E1A62DE3:'季度包',
    _B8D34DAC4DE3D1B9:'半年包',
    _647D1BC9E5D4E37E:'年流量包',
    _F68731BF30C6D6FF:'立即购买',
    _C6B1159F04279B97:'有效期1个月',
    _8EAC5F3B1C8DDDE3:'有效期3个月',
    _8DCB106118246E1B:'有效期6个月',
    _E2421060E4B97E01:'有效期12个月',
    _2023CF429CD0DE66:'多人同时在线不限制',
    _C4F865E57E7C90B7:'权益+20%',
    _0DEB9CECF09C0749:'导出数据',
    _A72A7E36CEFC8141:'导出公司数据',
    _1354FFCD976768E2:'锁定目标客户',
    _B5A4381117F508EB:'公司列表查看页数 (1000页）',
    _677CFC6879FDD3AB:'Facebook查看页数(1000页）',
    _A9234E81A0A830B7:'查看Facebook详情',
    _B7961A6865C64D35:'高效联系',
    _841B0B18D21CBE86:'发送消息到目标客户邮箱',
    _CAC9870C876EB137:'发送Facebook Messenger',
    _DA1496E51CA18063:'流量包单项-单次购买',
    _5EF37453FABC3894:'加急包类型',
    _2E469ACDFB291633:'流量包内容',
    _8B4A25C684B6E0AD:'加急包-查看联系邮箱',
    _676616EDE85D3013:'加急包-查看公司详情',
    _3128E373BA3F2E81:'加急包-查看社交账号',
    _120BEAFFBA5A67A1:'加急包-发送消息',
    _BEB79A09ED580B53:'查看目标客户联系邮箱-1次',
    _D3DC67549ED07FF0:'查看公司详情-1次',
    _24589C4F33C1A5B1:'查看个人社交账号-1次',
    _6C53860262CEB10C:'发送消息给目标客户-1次',
    _15B57482F2F0E565:'多种会员方案供选，丰富的使用场景',
    _AA44493F4B0D33FC:'全球1亿+企业数据全面呈现，超过3亿企业关键联系人信息，有的放矢',
    _F05469193B97F3FE:'销售团队成员建立客户清单',
    _6DDF8CA9F3BC9DD9:'招聘人员高效挖掘合适的候选人',
    _B3338999BE1CB4CE:'业务员快速开发有效的海外客户',
    _43D1C28F63F75827:'了解未知的海外市场前景',
    _844C9D7476024708:'实时追踪竞争对手和合作伙伴的商业数据',
    _3882130FD053559A:'防范贸易风险，放心进行全球交易',
    _4154A3DB616B7A96:'支付确认',
    _D1226BA6735A6C8D:'您已选中',
    _C7AAD1CD5D9FCD04:'实付金额',
    _783C0154A9B122A5:'渠道优惠价',
    _2E301881AEDFD0AE:'请选择数量',
    _4F5BB4FF8B3D804B:'确认',
    _2E511950B65244C7:'联络',
    _7657672C881EBD51:'精准找到目标关键人，连接更全面更准确更实时的商业联系人数据',
    _77B64F300B35CF3B:'多维度联系人数据让您更精准找到目标 客户，让您的营销内容更击中目标',
    _F32850B8A9E82DD5:'通过地理位置、所在公司及岗位级别 和行业筛选让你更好找到目标候选人',
    _3858AA3A43F459A2:'流量包订单',
    _686E3EA3EFAD37C3:'征信报告订单',
    _69EEEF5748E852C1:'操作',
    _8F13FA997BAEDAAD:'待支付',
    _E292B9EF3A399EE4:'已完成',
    _84EAE80A1D012926:'已失效',
    _05D6125395E3C7E7:'查看详情',
    _25AF4E2F8690AE07:'删除订单',
    _82C50AC706BB4533:'列表查看页数',
    _60BF6B11512CBEB4:'发送消息',
    _5870C192FAC1EEA9:'剩余页数',
    _10DF03B39223BB12:'剩余次数',
    _B0E4375E1B031799:'已使用',
    _2C3A5F985737A8A9:'已过期',
    _D32D883DAE20353D:'额度使用明细',
    _F1B99979E1B7D5B4:'明细',
    _0C9B77AC17EBAD7F:'使用时间',
    _D93621A8D2D68018:'升级VIP',
    _7F28764B786320F9:'企业认证',
    _D6D6566556C3D365:'VIP套餐',
    _7F308959CD74F262:'企业认证的益处',
    _758296A5045A5A59:'增加曝光',
    _F9FD779FAD0D3F43:'您的企业将在企业搜索库展示，全球B2B买家可以通过引擎搜到您的企业',
    _99BA2EA6CF829212:'获得D币',
    _8BCB871BC3E7CAC7:'现在认证，即可一次性获得100D币，D币可用于兑换查看公司，查看联系方式额度',
    _76CBEAB49C1CC678:'精准推荐',
    _73759755906D8208:'系统将依据您的企业情况，提供给您更符合的企业资讯数据',
    _B166E4E8FE9513FA:'国家',
    _6946655DE7F72092:'请选择国家',
    _0F99D46E818819F8:'请选择公司规模',
    _8758FD50C87D6C9C:'地址',
    _FD8587589210CB9F:'请输入地址',
    _3D5CE01C5F6E820A:'营业执照',
    _B022BD8F08A02EB3:'工牌',
    _3BA773287B7DEF95:'请上传图片',
    _5AEC26A6B7BB80E8:'注：名片和工牌必须上传一个',
    _17F2456ABA6229BA:'立即认证',
    _F15FCB490CFA7DF2:'您已成功提交如下企业认证，我们将会在3-5个工作日审核您的企业信息，请耐心等待',
    _18A470EEFF7A2BED:'审核状态',
    _FC3D3C119118CFFC:'修改认证信息',
    _99974E94A167C813:'修改认证信息需重新提交审核',
    _1B8E1319E4881C25:'您认证的公司已成功通过审核，恭喜您获得100D币奖励，请到我的D币页面查看并使用',
    _993C4E2A71557FE7:'审核通过',
    _C9815C7193A12837:'更换认证公司',
    _1294A3AED15D022E:'价格及权益',
    _E55D90826AD83005:'权益',
    _CD4657BF621206D1:'万里查VIP会员流量包',
    _CF658B12CFCACE9A:'公司列表查看页数',
    _C9B453CE1F6E81A0:'Facebook查看页数',
    _62EDE6F38D74952C:'查看目标客户联系邮箱-',
    _DF78000CFB3A3DAF:'查看公司详情-',
    _93B1BADF4D561AEA:'查看个人社交账号-',
    _D9A3A5133BD74670:'发送消息给目标客户-',
    _D5409BECB32337C4:'销售团队成员',
    _8A68FC40A519E93D:'建立客户清单',
    _628916824D3611C6:'招聘人员高效挖掘',
    _E1678256F89F2F07:'合适的候选人',
    _6A246988E6574D4C:'业务员快速开发',
    _76502B4C0B2CC606:'有效的海外客户',
    _90700C0A59C88173:'了解未知的海外',
    _5560BA1B53C02E4B:'市场前景',
    _512DAB7B61817835:'实时追踪竞争对手和',
    _D61A8BFACAD470FA:'合作伙伴的商业数据',
    _4976DD8DEFF79A51:'防范贸易风险',
    _6C521DB90B48332E:'放心进行全球交易',
    _C10448D12335D659:'更换认证公司需重新审核，请谨慎更换',
    _7B5766A1C5EF255D:'很抱歉，您提交的企业认证未通过审核，请重新提交认证。',
    _735DF2DCA58C4F9B:'重新提交',
    _7FE92F41627D9A70:'审核不通过',
    _EDC06299F5ACEA79:'基础权益',
    _54D0E13A0A2F880B:'认证您的企业',
    _58E3259AA361FB13:'实付价格',
    _C6C48A3A73691AAA:'加急包价格',
    _087FA94C1AFFC0E0:'我的额度',
    _515CC1FF24493A7B:'列表页数查看',
    _A01B988E7E9A6DC2:'Facebook页数查看',
    _B2E08912B2D8BDA7:'查看Facebook详情',
    _85269AFA54303AAE:'查看社交账号',
    _C5DC9F9EC32360D8:'发送FB Messenger',
    _3B80861F5CC1D41F:'订单明细',
    _EED7E53868D52E10:'您的订单已提交，请在',
    _DFAE9AA678140754:'前完成支付，超时则自动取消。',
    _BBD0E1F1214BCA9D:'支付订单可享受更多会员权益。支付过程若有遇到任何问题，可随时',
    _DDB77881EE372EBA:'立即支付',
    _AA37B3A822347601:'您的订单已经失效，请重新购买会员流量包。',
    _43B4D384BC9DAB4F:'了解会员权益',
    _161AA79CAB995327:'购买数量',
    _CD390002E8406C5B:'余额抵扣',
    _8FD6CE9C58001E36:'支付时间',
    _5FF8D4C1679F272E:'最少5个字符',
    _7E461A1085F629F3:'关注公众号',
    _1D6BC498A0AD979C:'手机也能找客户',
    _7005434934422454:'公众号',
    _82725C780D821B2D:'请输入至少5个字符',
    _795E7E3ECBD225AB:'秒出报告',
    _93B20BBDF1ADBE0A:'目录',
    _88233F21F5A4D78F:'按浏览名称',
    _8A182451A9CE6F93:'个人中心',
    _BF665AB539D16DC8:'最多可购',
    _412F91CC17DC0AC9:'万里查非常重视对您的个人隐私保护，有时候我们需要某些信息才能为您提供您请求的服务，本隐私政策解释了这些情况下的数据收集和使用情况。 本政策适用于中国素描网的所有相关服务，随着万里查服务范围的扩大，隐私政策的内容可由万里查随时更新，且毋须另行通知。更新后的隐私政策一旦在网页上公布即有效 代替原来的隐私政策。',
    _DEC5D681B64A5632:'我们收集哪些信息',
    _A4A36D4856D34219:'通常，您能在匿名的状态下访问万里查并获取信息。当我们需要能识别您的个人信息或者可以与您联系的信息时，我们会征求您的同意。 通常，在您注册万里查或申请开通新的功能时，我们可能收集这些信息： 姓名、E-mail地址以及相关账号，并征求您的确认。',
    _B3757F11D1BCAA7F:'关于您的个人信息',
    _73D2FA4D2C92EE73:'万里查严格保护您个人信息的安全。 我们使用各种安全技术和程序来保护您的个人信息不被未经授权的访问、使用或泄漏。 万里查会在法律要求或符合中国素描网的相关服务条款、软件许可使用协议约定的情况下透露您的个人信息，或者有充分理由相信必须这样做才能：',
    _60C5902D4D65DE2C:'3.1满足法律或行政法规的明文规定，或者符合中国素描网站适用的法律程序；',
    _059BA874B494B559:'3.2符合万里查相关服务条款、软件许可使用协议的约定；',
    _01F52D5C5AD86CA7:'3.3保护万里查的权利或财产；',
    _58365E0B7C28B1E7:'3.4在紧急情况下保护万里查员工、万里查产品或服务的用户或大众的个人安全； 万里查不会未经您的允许将这些信息与第三方共享，本政策已经列出的上述情况除外。',
    _654DBD543EDC5D26:'Cookie的使用',
    _609CE37FD7E11B55:'使用 Cookie 能帮助您实现您的联机体验的个性化，您可以接受或拒绝 Cookie ，大多数 Web 浏览器会自动接受 Cookie，但您通常可根据自己的需要来修改浏览器的设置以拒绝 Cookie。 万里查有时会使用 Cookie 以便知道哪些网站受欢迎，使您在访问万里查时能得到更好的服务。Cookie不会跟踪个人信息。 当您注册万里查时，万里查亦会使用 Cookie。在这种情况下，万里查收集并存储有用信息，当您再次访问万里查时，我们可辨认您的身份。来自万里查的 Cookie 只能被万里查读取。 如果您的浏览器被设置为拒绝 Cookie，您仍然能够访问万里查的大多数页面。',
    _E98552440A14FC2D:'今天',
    _8F2AC94D299863D2:'<span>{month}</span>月<span>{day}</span>日',
    _D90AFC839E21FA5B:'已选条件',
    _0F8358C65FE66F79:'联系人',
    _525868CDA60043F2:'成为VIP会员，最多可查看12万+企业',
    _FB32013333CD2CE7:'历史筛选条件',
    _411D7230C59C0938:'批量收藏',
    _678081DF0A506847:'默认排序',
    _70AEBC7CB2C3BF43:'联系人数量由高到低',
    _4B8B490C9ACEF433:'公司规模由高到低',
    _8DB2C5A12BA851DF:'有联系方式的靠前排序',
    _2A3EB2C5085C0F8B:'相关度由高到低',
    _1D525A47080B3266:'有无官网',
    _703329EE674D8D5C:'有',
    _C792CE60D7B74561:'有无邮箱',
    _2AF208DE295242D9:'有无Facebook',
    _2B09804B237266EF:'有无Twitter',
    _65FFE1FB981C3E69:'有无Linkedin',
    _0E1AC645D285DEBD:'有无联系人',
    _F5363AA6057CD9B7:'Facebook热门公司',
    _41DDED4E5A874E33:'点赞数',
    _7A7BE43D8C529286:'详细信息',
    _F5B7BDACBDB75254:'产品服务',
    _F7F35F0718F69267:'加入VIP，马上与您的目标联系人取得联系',
    _D80C976303D9CCB5:'共找到约<span>{count}</span>个Facebook',
    _6BD886529679374E:'Facebook列表',
    _A68A744713E0120C:'社交媒体',
    _18CED93371CC4D73:'公司介绍',
    _0CEE229E93A8DF5F:'公司概况',
    _81F1CAB5330BF0DD:'公司产品',
    _9B5BBEF1BFA55E03:'公司使命',
    _FB16C496D4911C61:'关于',
    _BD4B710BCC5F4B5B:'所获奖项',
    _B1A6BA95390AACB7:'电话',
    _FF67B921FF8F8A58:'我知道了',
    _4186D5B29C4328F5:'企业信息',
    _DBF8358C8B6070A4:'审核状态:',
    _7DC52CA148301B8A:'公司名称:',
    _5D76AA4FE8627E14:'行业:',
    _6384AE200B496CA4:'地址:',
    _2C2BF85DF52B91B2:'国家:',
    _0286713B19EF5687:'公司规模:',
    _DB6870C43D1B8D27:'审核成功',
    _0C439D7C35AC71B1:'修改名片',
    _DBF2505F561DE5B7:'修改营业执照',
    _E2FBB28A37D3BBCF:'修改工牌',
    _3B4093E80AA8F2E3:'点此出上传图片',
    _BD7218F3625BAF11:'注：营业执照必须上传，名片和工牌必须上传一个',
    _5CDEE8373ADDFBA2:'文件格式',
    _44EAC0552CD27AF0:'导出数量',
    _A21303236771D4F2:'您有<span>{count}</span>条额度，最多可以导出<span>{count}</span>条数据',
    _8DBC350DEE25378F:'您认证的公司已成功通过审核，恭喜您获得<span>100D币</span>奖励，请到<span>我的D币</span>页面查看并使用',
    _70C234DE98CF9247:'1.使用范围',
    _C48E2D74C079996E:'D币是Xieco万里查用户的专属积分，仅限Xieco万里查内使用。D币不能兑现，不可转让。',
    _2FD44CB8FEC4A13A:'2.D币如何获得？',
    _A9F248324C0C18C0:'2.1.分享得D币：用户通过分享公司/联系人/名片信息等，每次分享可获赠10个D币。每天通过分享可获得的D币上限为30个D币，超出后分享将不再获赠D币。',
    _D129F1C573975E27:'2.2.认证企业：用户提交企业认证并审核通过，一次性可获得100个D币（每个用户只能获得一次，重复提交认证不计数）',
    _CD27A450824D3F68:'2.3.购买流量包回馈D币：购买月流量包（$58）返100D币，购买季度包（$175）返300个D币，购买半年包（$348 ）返回600个D币，购买年流量包（$696）返回1200个D币。若有退款产生，则之前购买获赠的D币将扣除。',
    _2157E8D5E75606EE:'3.D币的用途',
    _36E456C79F7D5873:'D币可用于兑换权益。在我的D币页，点击兑换额度按钮，可以用D币兑换相应的查询额度。',
    _7DFAAFBC3A676A4B:'4.D币有效期',
    _1FA56E2954C5756B:'D币有效期至少1年，即从获得之日起，到次年年底过期。如2018年11月1日获得的D币，将于2019年12月31日过期。',
    _E38BAF2CA6F42949:'点此处上传图片',
    _A7580E69ACA1BDAB:'想了解大家都在搜什么？',
    _DF14BE791D9932C9:'登录可查看Facebook上相关的热门公司',
    _56E64691BE015010:'立即登录',
    _E014896D68F0D78B:'已选中0个国家/地区',
    _5CED18A1AC891A5E:'清除选项',
    _3FEC82CE8F08AA82:'已选中0个行业',
    _8DB71808C4599307:'选择行业',
    _53C98343C08C2E0B:'对不起，您的邮箱查看额度不足',
    _BAE973FB30CFECC0:'现在成为VIP会员，',
    _B347062306761250:'与精准客户建立联系仅需20元',
    _1F572A3F8A54EB9B:'对不起，您的额度不足',
    _6E62945C1A3FCDD0:'联系目标客户最低仅需1元',
    _1C013486334DBBC1:'关联推荐',
    _1B52E217C72A9BE8:'Facebook详情',
    _833BA210DA47F161:'您已成功提交如下企业认证，我们将会在<span>3-5个工作日</span>审核您的企业信息，请耐心等待',
    _31118F6057E40723:'热门',
    _8774F498D56F0267:'对不起，您还不是VIP会员',
    _9E962915E74776D0:'批量收藏功能仅针对VIP会员开放',
    _6B7A506DF07E24EB:'导出数据功能仅针对VIP会员开放',
    _8516A25B9937E253:'查看会员权益',
    _0A9E19A467545466:'已选中<span>{count}</span>个国家/地区',
    _03B942E0C95F5280:'已选中<span>{count}</span>个行业',
    _595330AEE6DFB56A:'查看Facebook',
    _3F77F29B048D0423:'与精准客户建立联系仅需<span>20</span>元',
    _D19866415C9C2C88:'联系目标客户最低仅需<span>1</span>元',
    _960EAA175D30F453:'万里查介绍',
    _F06B663440722A0E:'一款为全球贸易企业智能匹配生意人脉的安全社交工具',
    _ECA5319C024D6D60:'实时动态更新',
    _B988E6B78434FD73:'全球1亿+企业数据全面呈现',
    _6D19D21998CDA2B6:'融合社交数据',
    _73A5FA110D45D286:'超过3亿企业关键联系人信息，有的放矢',
    _2F8700942BD73843:'是通过推荐全球企业以及联系人数据来提供销售线索，从而促成全球买家和卖家之间实现更多交易的智能大数据平台。我们拥有全球领先的人工智能技术和大数据团队，可为全球用户提供超亿级的全球企业和联系人数据。我们的数据每天都在增长并实时更新，确保我们的用户可以快速、轻松地找到所需的信息，提高销售效率，拓展更多业务。',
    _DDCE6E478C68A5E0:'目前我们已经帮助上千家的企业直接联系匹配的业务对接人，实现可观的销售利润增长。未来，我们还将利用人工智能技术帮助更多的海内外中小企业发现更多的全球合作伙伴，挖掘更多的商机。',
    _C4DA041BFD213E1D:'我们能做什么',
    _5D62F3D282959661:'找到你的目标关键人',
    _49154FDEEFE3F71D:'我们利用先进的人工智能技术来匹配买卖双方的真实需求，为您推荐精准的潜在客户。',
    _FF08D7BDA0D3F8B9:'建立高效联系',
    _24022185937A834B:'在万里查,您可以与您的客户进行有效沟通， 并建立诚信可靠的商业联系。',
    _8B268CCE0C61A29D:'做出正确的贸易决策',
    _4F08BC308FA0EF86:'我们从多维度分析您的目标客户，并为您提供有效的决策支持，保障交易安全。',
    _347941C071AE6CCA:'数据能力',
    _5592B0E35C55E998:'数据预测与推荐/天',
    _AA3E00B1A9D2605A:'亿',
    _772E3C2A629C768E:'动态行为与意向信号/天',
    _8A6D78DEA3A458AB:'特征向量',
    _C195EB37AF029F1F:'全球采购商与供应商',
    _F7A6B6F4A9CF0B12:'企业联系人',
    _9373ABF6DD8E3767:'选择我们的理由',
    _153177D1FDB74082:'数据覆盖度广',
    _D7D2F9BC045940D9:'全球165个国家及地区，涉及600多个行业',
    _C05CA957E3932A7F:'数据颗粒度',
    _8E7FE4F59A7F8BAC:'包含企业详情、联系人联系信息、联系人各类社交媒体信息',
    _3911553855F8A514:'数据来源权威',
    _19884A8F37B741A6:'多种官方渠道收集+技术分析，保证数据实时性、通畅性和准确性',
    _5D4CF1480A06A05F:'定位目标客户',
    _77FAACDD490B3585:'多种筛选条件+多种联络方式，轻松定位目标客户群',
    _89C389FAA18C1F1B:'全面了解买家',
    _719DCE77B166795F:'实时掌握全球买家信用的最新动态，识别潜在商机',
    _F4F5A91B7E986656:'我们的实力',
    _F9F7BACC44B0A90C:'分布式',
    _B888517CEC352DD8:'数据抓取',
    _889B3CA3102BEAC9:'帮助企业融合动态数据和静态数据',
    _E9DF76CBEA3E8B6A:'帮助企业智能创建客户画像',
    _226D25B79D019F73:'精准',
    _DC2F6E3A2C6C3654:'拓展优质客户',
    _C14E1933AAE3EE7E:'经过验证的高效智能营销体系',
    _E3C94A87545E3F6C:'高触达',
    _D4A774A5835C000E:'好体验',
    _3EDA8E06EC8D091C:'低流失',
    _FEAD3F6C88F821BF:'数据搜索引擎，业界公开数据集上',
    _8082935BAC48B34D:'第一水准',
    _818CE541FF39BBD1:'数据推荐引擎，基于用户画像模型',
    _DC9B5221D04F67A9:'精准匹配',
    _98531B67597D79C4:'企业，直接建立联系',
    _93330F1C8FEFD289:'基于自然语义识别和推荐，端到端建模，每天超',
    _4B0727F8DB77BE1D:'的',
    _61C7A729A4CA7963:'20亿',
    _A42F9ED9DB4DB973:'动态',
    _D00DD36669CD0C86:'与',
    _DB550E57457AA660:'意图捕捉',
    _074ABD9CF3AC8535:'分享Facebook',
    _25A1F35304DA4DBB:'分享Twitter',
    _B29E6F6C86C23848:'分享Linkedin',
    _D2CF966D7BBCC322:'分享微信',
    _20A634B518BB8103:'分享微博',
    _ACDFBFD5132FE350:'通过分享链接注册',
    _155042025D07324E:'购买月套餐',
    _2BBA3753BC01C3F8:'购买季度套餐',
    _311546848E751761:'购买半年套餐',
    _31F4FDD1DDA2CDC9:'购买年套餐',
    _62702A6EDDDA26D9:'兑换查看联系邮箱额度',
    _6A242D1F013C7EB6:'兑换查看公司详情额度',
    _9E111B4ABDB2A0FC:'兑换消息联系额度',
    _CF0258D0B0AF7F87:'兑换查看Facebook额度',
    _75EF6CBEED6A92F6:'兑换查看个人社交账号额度',
    _69C3E157024665BD:'兑换发送消息额度',
    _B5898A0C554C586D:'导出列表数据',
    _6C683CEC3A7B8B67:'注：此处导出的是公司列表页的数据，如需导出收藏公司的数据，请到我的收藏页操作',
    _40FB5DC5EF586FCC:'注：此处导出的是人脉列表页的数据，如需导出收藏人脉的数据，请到我的收藏页操作',
    _345D01829034D9F4:'导出收藏数据',
    _807437709BF9753D:'获得一个不受限制的增长机会',
    _EE3731506832E2D2:'从万里查数据查询平台开始',
    _FB85E32BE7F6A57F:'企业数据、邮箱数据、社交数据',
    _46ED9F28018BE4D7:'获取目标关键联系人',
    _9F7C34139DA83EB7:'我们利用先进的算法，来匹配买卖双方的真实需求，帮您获取精准的潜在客户',
    _3255BF759FCBD3B1:'定位目标市场精准客户',
    _C05C0D30D1046CAA:'万里查组合搜索：产品名称+国家+商务目的城市，即可定位/沟通你目标城市的所有优质买家',
    _83C628AE18504403:'建立全面的联系矩阵',
    _438849682D21F439:'在万里查，您可以获取潜在客户的全面联系信息，发起有效沟通，并建立诚信可靠的商业联系',
    _561B528BBA3A252D:'快速了解买家背景信息',
    _1EE0009001B0FB46:'我们从多维度分析您的目标客户，并为您提供有效的实时客户信息，完善的卖家背景信息',

}
export default gen



// WEBPACK FOOTER //
// ./src/lan/cn/cn_gen.js